import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CustomerRequestFilterState = {
  type?: string;
  status?: string;
  dateRange?: string;
  fromDate?: string;
  toDate?: string;
  customerId?: string;
};

export type CustomerRequestState = {
  data: CustomerRequest[];
  pagination: PaginationAPI;
  loading: boolean;
  filters: CustomerRequestFilterState;
  dataDetailsCustomerRequest?: DetailCustomerRequest;
  requestStatus: RequestStatusType[];
  requestType: RequestTypeType[];
  dataOverViewDetail?: CustomerRequestOverviewType;
};

export const CustomerRequestInitialState: CustomerRequestState = {
  data: [],
  filters: {},
  pagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  loading: false,
  dataDetailsCustomerRequest: undefined,
  requestStatus: [],
  requestType: [],
  dataOverViewDetail: undefined,
};

const slice = createSlice({
  name: 'customerRequest',
  initialState: CustomerRequestInitialState,
  reducers: {
    setListCustomerRequestAction(
      state,
      action: PayloadAction<{
        data: CustomerRequest[];
        pagination?: PaginationAPI;
        totalExtend?: number;
      }>,
    ) {
      const { payload } = action;
      state.data = payload.data;

      state.pagination = payload.pagination || state.pagination;
    },
    setCustomerRequestLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setDetailsCustomerRequestAction(
      state,
      { payload }: PayloadAction<DetailCustomerRequest | undefined>,
    ) {
      state.dataDetailsCustomerRequest = payload;
    },
    setRequestStatusAction(
      state,
      action: PayloadAction<{
        requestStatus: RequestStatusType[];
      }>,
    ) {
      const { payload } = action;
      state.requestStatus = payload.requestStatus;
    },
    setRequestTypeAction(
      state,
      action: PayloadAction<{
        requestType: RequestTypeType[];
      }>,
    ) {
      const { payload } = action;
      state.requestType = payload.requestType;
    },
    setCustomerRequestFiltersAction(state, action: PayloadAction<CustomerRequestFilterState>) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetCustomerRequestFiltersAction(state) {
      state.filters = {};
    },
    updateCustomerRequestAction(state, { payload }: PayloadAction<CustomerRequest>) {
      state.data = state.data.map((item) => {
        if (item.id === payload.id) {
          return payload;
        }
        return item;
      });
    },
    setCustomerOverviewAction(state, { payload }: PayloadAction<CustomerRequestOverviewType>) {
      state.dataOverViewDetail = payload;
    },
  },
});

export const {
  setListCustomerRequestAction,
  setCustomerRequestLoading,
  setDetailsCustomerRequestAction,
  setCustomerRequestFiltersAction,
  resetCustomerRequestFiltersAction,
  updateCustomerRequestAction,
  setRequestTypeAction,
  setRequestStatusAction,
  setCustomerOverviewAction,
} = slice.actions;
export default slice.reducer;
